// services/frontend/src/components/NoHeaderLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * 헤더/사이드바 없이 콘텐츠만 렌더링하는 WebView 전용 레이아웃
 */
export default function NoHeaderLayout() {
  return (
    <div className="no-header-layout app-container" style={{ minHeight: '100vh', background: '#fff' }}>
      <main className="main-content" style={{ padding: '0 14px' }}>
        <Outlet />
      </main>
    </div>
  );
}
